export { default as DashboardC } from './components/dashboard';
export { default as LoadingbarC } from './components/loadingbar';
export { default as SnackbarC } from './components/snackbar';

export { default as CancelarButtonC } from './components/cancelarButton';
export { default as EliminarConfirmacionC} from './components/eliminarConfirmacion';
export { default as NotificacionC } from './components/notificacion';
export { default as VolverButtomC } from './components/volverButtom';
export { default as LoadingScreenC } from './components/loadingScreen';
export { default as SeleccionadorC } from './components/seleccionador';

export { default as GMapsC } from './components/gMaps';
export { default as GMapsTrayectoC } from './components/gMapsTrayecto';



// WEBPACK FOOTER //
// src/modules/general/component.js